/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  box-sizing: border-box;
  display: inline-block;
  margin-right: calc(0.8571428571rem);
  min-width: calc(2rem);
  min-height: calc(2rem);
  font-size: 1rem;
}
:host davinci-icon-ref {
  width: calc(2rem);
  height: calc(2rem);
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
}
:host davinci-icon-ref.disabled {
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}

:host([active]:not([disabled])) davinci-icon-ref {
  fill: #009DF4;
  fill: var(--davinci-color-primary-light, #009DF4);
}

:host(:not([disabled])) davinci-icon-ref:hover {
  cursor: pointer;
  fill: #009DF4;
  fill: var(--davinci-color-primary-light, #009DF4);
}`;
export { style };
